<template>
  <div class="FormView">
    <div class="formWrapper" v-if="!sentData">
      <div class="container" v-if="!!bigCall">
        <div class="bigCall imageWidgetWrapper">
          <image-widget 
            :key="bigCall.id"
            :title="bigCall.title"
            :sub-title="bigCall.subTitle"
            :img="bigCall.img"
            :cta-href="bigCall.ctaLink"
            :cta-text="bigCall.ctaText"></image-widget>
        </div>
      </div>
      <div class="topTextWrapper">
        <generic-big-text 
          :text="topText.text"
          :btn-text="topText.btnText"
          :btn-href="topText.btnHref"
          :btn-style="topText.btnStyle"
          :bg-style="topText.bgStyle"
          :text-color="topText.textColor"></generic-big-text> 
      </div>

      <div class="formWrapper container">
        <div class="flexRow">
          <div class="formWrapperIntro">
            <h3 class="title" v-html="formWrapperTitle">
            </h3>
            <div class="formWrapperContent" v-html="formWrapperContent">
            </div>
            <div class="form">
              <project-form
                :project="project"
                :form-action="formAction"
                :rules="rules"
                :success-text="successTopText"
                @success="setSentData"
                ></project-form>
            </div>
          </div>
          <div class="sidebarWrapper">
            <h3 class="title" v-html="sidebarTitle">
            </h3>
            <div class="sidebarContent">
              <div class="sidebar" v-html="sidebarContent"></div>
              <div class="linksWrapper">
                <a :href="pdfRules" target="_blank" v-html="pdfRulesText"></a><br />
                <a :href="pdfHandbook" target="_blank" v-html="pdfHandbookText"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomBigTextWrapper">
        <generic-big-text 
          :text="bottomBigText.text"
          :btn-text="bottomBigText.btnText"
          :btn-href="bottomBigText.btnHref"
          :btn-style="bottomBigText.btnStyle"
          :bg-style="bottomBigText.bgStyle"
          :text-color="bottomBigText.textColor"></generic-big-text>
        </div>
    </div>
    <div class="thankyouWrapper" v-if="!!sentData">
      <div class="successWrapper">
        <generic-big-text 
          :text="successText.text"
          v-if="!!sentData"></generic-big-text>
      </div>
      <div class="container">
        <div class="socialBtnsContainer">
          <social-btns
            :share-url="shareUrl"
            :share-subject="shareSubject"
            :share-email-subject="shareEmailSubject"
            :share-email-body="shareEmailBody"></social-btns>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import GenericBigText from './generic_big_text'
  import ImageWidget from './image_widget'
  import ProjectForm from './project_form'
  import SocialBtns from './social_btns'


  export default {
    name: 'FormView',
    components:{
      GenericBigText,
      ProjectForm,
      ImageWidget,
      SocialBtns
    },

    data(){
      return {
        sentData: false
      }
    },
    methods: {
      setSentData(){
        var event = new CustomEvent('submittedForm');
        window.dispatchEvent(event);
        this.sentData = true;
      }
    },
    props: {
      topText: {
        type: Object,
        default: ()=>{}
      },
      project: {
        type: Object,
        default: ()=>{}
      },
      formWrapperTitle: {
        type: String, default: ""
      },
      formWrapperContent: {
        type: String, default: ""
      },
      sidebarTitle: {
        type: String, default: ""
      },
      sidebarContent: {
        type: String, default: ""
      },
      pdfRules: {
        type: String, default: ""
      },
      pdfRulesText: {
        type: String, default: ""
      },
      pdfHandbook: {
        type: String, default: ""
      },
      pdfHandbookText: {
        type: String, default: ""
      },
      formAction: {
        type: String, default: ""
      },
      rules: {
        type: String, default: ""
      },
      successTopText: {
        type: Object, default: ()=> {}
      },
      bigCall: {
        type: Object,
        default: ()=>{}
      },
      bottomBigText: {
        type: Object,
        default: ()=>{}
      },
      successText: {
        type: Object,
        default: ()=>{}
      },
      shareUrl: {
        type: String,
        default: window.location.href
      },
      shareSubject: {
        type: String,
        default: ""
      },
      shareEmailSubject: {
        type: String,
        default: ""
      },
      shareEmailBody: {
        type: String,
        default: ""
      }
      
    },
    computed: {
    },

  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';

  .title{
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 10px;
    border-bottom: 1px solid #000;
    font-weight: 700;
    padding-bottom: 10px;
    @media (max-width: @bootstrap-md - 1px){
      font-size: 22px;
      line-height: 30px;
    }
  }

  .sidebar{
    margin-bottom: 33px;
    @media (max-width: @bootstrap-md - 1px){
      margin-bottom: 0;
    }
  }

  .linksWrapper{
    a:link, a:visited, a:hover, a:active{
      text-decoration: underline;
      line-height: 42px;
    }
    @media (max-width: @bootstrap-md - 1px){
      margin-bottom: 25px;
    }
  }

  .bigCall{
    margin-bottom: 50px;
    margin-top: 53px
  }

  .flexRow{
    display: flex;
    @media (min-width: @bootstrap-lg){
      .formWrapperIntro{
        flex: 1 0 70%;
      }

      .sidebarWrapper{
        flex-grow: 1;
        margin-left: 33px;
      }
    }

    @media (max-width: @bootstrap-lg - 1px){
      flex-direction: column;
      .formWrapperIntro{
        flex: 1 0 auto;
        order: 2;
      }

      .sidebarWrapper{
        flex-grow: 1;
        margin-top: 33px;
        order: 1;
      }
    }
  }

  .formWrapperContent{
    font-size: 18px;
    line-height: 28px;
    margin-top: 30px;
    @media (max-width: @bootstrap-md - 1px){
      font-size: 16px;
      line-height: 24px;
    }
  }

  .bottomBigTextWrapper{
    margin-top: 120px;
  }
  .socialBtnsContainer{
    @media (min-width: @bootstrap-lg){
      max-width: 860px
    }
  }

  /deep/ .subTitle{
    padding-bottom: 8px;
    border-bottom: 1px solid #000;
  }

  .successWrapper /deep/ .bg{
      padding-top: 80px !important;
  }

  .topTextWrapper{
    margin-top: 50px;
  }
</style>
